/* eslint-disable */
import React from "react";
import Sidebar from "../../components/sidebar/Sidebar2";
import { useEffect, useState } from "react";
import Navbar from "../../components/navbar/Navbar2";
import {
  doc,
  serverTimestamp,
  addDoc,
  updateDoc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useSelector } from "react-redux";
import { Switch } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  Info,
  CreditCard,
  Smartphone,
  DollarSign,
  Wallet,
  Save,
  AlertCircle,
  CheckCircle,
  Loader,
  Clock,
} from "lucide-react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const PaymentMethodsPage = () => {
  const { t, i18n } = useTranslation();
  const [showSideBar, setShowSideBar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [verifyingSlickPay, setVerifyingSlickPay] = useState(false);

  const createDefaultPaymentMethods = (t) => ({
    slickpay: {
      enabled: false,
      accountId: "",
      apiKey: "",
      name: t("paymentMethods.methodsList.slickpay.name"),
      description: t("paymentMethods.methodsList.slickpay.description"),
      image:
        "https://play-lh.googleusercontent.com/RNixvQLeIChh3f0pfYQ2asBCMbjTw0tCBHLFObcnQ2DMftqPM9D5HatPW0MqqFR8vfY",
      iconName: "Smartphone",
      color: "bg-blue-500",
    },
    stripe: {
      enabled: false,
      accountId: "",
      name: t("paymentMethods.methodsList.stripe.name"),
      description: t("paymentMethods.methodsList.stripe.description"),
      image: "/aze.png",
      iconName: "CreditCard",
      color: "bg-purple-500",
    },
    // binance: {
    //   enabled: false,
    //   accountId: "",
    //   name: t("paymentMethods.methodsList.binance.name"),
    //   description: t("paymentMethods.methodsList.binance.description"),
    //   image:
    //     "https://public.bnbstatic.com/20190405/eb2349c3-b2f8-4a93-a286-8f86a62ea9d8.png",
    //   iconName: "DollarSign",
    //   color: "bg-yellow-500",
    // },
    ccp: {
      enabled: false,
      accountId: "",
      name: t("paymentMethods.methodsList.ccp.name"),
      description: t("paymentMethods.methodsList.ccp.description"),
      image:
        "https://play-lh.googleusercontent.com/hD-Vr6VMUPW9q_7ueTBHCuDB0GyKw43IcxxX4ctKWgUUQ2bNTjrsIudgqeC8WtjfKes=w526-h296-rw",
      iconName: "Wallet",
      color: "bg-green-500",
    },
    paypal: {
      enabled: false,
      accountId: "",
      name: t("paymentMethods.methodsList.paypal.name"),
      description: t("paymentMethods.methodsList.paypal.description"),
      image:
        "https://upload.wikimedia.org/wikipedia/commons/a/a4/Paypal_2014_logo.png",
      iconName: "DollarSign",
      color: "bg-blue-600",
    },
    redotpay: {
      enabled: false,
      accountId: "",
      name: t("paymentMethods.methodsList.redotpay.name"),
      description: t("paymentMethods.methodsList.redotpay.description"),
      image:
        "https://rp-static-apne1.s3.ap-northeast-1.amazonaws.com/index/img/favicon.png",
      iconName: "DollarSign",
      color: "bg-red-500",
    },
    wise: {
      enabled: false,
      accountId: "",
      name: t("paymentMethods.methodsList.wise.name"),
      description: t("paymentMethods.methodsList.wise.description"),
      image: "/wise.png",
      iconName: "Globe",
      color: "bg-cyan-600",
    },
    dukascopy: {
      enabled: false,
      accountId: "",
      name: t("paymentMethods.methodsList.dukascopy.name"),
      description: t("paymentMethods.methodsList.dukascopy.description"),
      image: "/Dukascopy.png",
      iconName: "Banknote",
      color: "bg-gray-700",
    },
    paymentLater: {
      enabled: false,
      accountId: "30", // délai par défaut
      name: t("paymentMethods.methodsList.paymentLater.name"),
      description: t("paymentMethods.methodsList.paymentLater.description"),
      image: "/payment-later.png",
      iconName: "Clock",
      color: "bg-orange-500",
    },
  });

  const [paymentMethods, setPaymentMethods] = useState(() =>
    createDefaultPaymentMethods(t)
  );

  useEffect(() => {
    setPaymentMethods((prev) => {
      const defaults = createDefaultPaymentMethods(t);

      const merged = Object.keys(defaults).reduce((acc, key) => {
        acc[key] = {
          ...defaults[key],
          enabled: prev[key]?.enabled ?? false,
          accountId: prev[key]?.accountId ?? "",
          apiKey: prev[key]?.apiKey ?? "",
        };
        return acc;
      }, {});
      return merged;
    });
  }, [i18n.language, t]);

  const [originalPaymentMethods, setOriginalPaymentMethods] = useState({});
  const digitalStore = useSelector((state) => state.digitalStoreReducer);

  const account = useSelector((state) => state.AccountReducer);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (account?.user) {
      loadPaymentMethods();
    }
  }, [account?.user]);

  const findSecretKeyDocByUser = async (userId) => {
    try {
      const q = query(
        collection(db, "secretKeys"),
        where("user", "==", userId)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0];
        return { id: doc.id, data: doc.data() };
      }
      return null;
    } catch (error) {
      console.error("Erreur lors de la recherche du document:", error);
      throw error;
    }
  };

  const loadPaymentMethods = async () => {
    try {
      setLoading(true);

      const secretKeyDoc = await findSecretKeyDocByUser(account.user);

      if (secretKeyDoc && secretKeyDoc.data.paymentMethods) {
        const data = secretKeyDoc.data;
        const updatedMethods = {
          ...paymentMethods,
          ...Object.keys(data.paymentMethods).reduce((acc, key) => {
            if (key === "slickpay") {
              if (paymentMethods[key]) {
                acc[key] = {
                  ...paymentMethods[key],
                  enabled: data.paymentMethods[key].enabled || false,
                  accountId: data.paymentMethods[key].accountId || "",
                  apiKey: data.paymentMethods[key].apiKey || "",
                };
              }
            } else if (key === "paymentLater") {
              if (paymentMethods[key]) {
                acc[key] = {
                  ...paymentMethods[key],
                  enabled: data.paymentMethods[key].enabled || false,
                  accountId: data.paymentMethods[key].accountId || "30",
                };
              }
            } else {
              if (paymentMethods[key]) {
                acc[key] = {
                  ...paymentMethods[key],
                  enabled: data.paymentMethods[key].enabled || false,
                  accountId: data.paymentMethods[key].accountId || "",
                };
              }
            }
            return acc;
          }, {}),
        };
        setPaymentMethods(updatedMethods);
        setOriginalPaymentMethods(updatedMethods);
      } else {
        setOriginalPaymentMethods(paymentMethods);
      }
    } catch (error) {
      console.error(t("paymentMethods.messages.load.error"), error);
      toast.error(t("paymentMethods.messages.load.error"));
    } finally {
      setLoading(false);
    }
  };

  const verifySlickPayToken = async (apiToken) => {
    try {
      setVerifyingSlickPay(true);

      const response = await fetch(
        "https://prodapi.slick-pay.com/api/v2/users/accounts",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${apiToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (
        data &&
        data.data &&
        Array.isArray(data.data) &&
        data.data.length > 0
      ) {
        const defaultAccount = data.data.find((item) => item.default === 1);
        const accountUuid = defaultAccount
          ? defaultAccount.uuid
          : data.data[0].uuid;

        if (accountUuid) {
          const updatedMethods = {
            ...paymentMethods,
            slickpay: {
              ...paymentMethods.slickpay,
              accountId: accountUuid,
              apiKey: apiToken,
            },
          };
          setPaymentMethods(updatedMethods);
          checkForChanges(updatedMethods);

          toast.success(t("paymentMethods.messages.verifySlickpay.success"));
          return true;
        } else {
          toast.error(
            t("paymentMethods.messages.verifySlickpay.accountNotFound")
          );
          return false;
        }
      } else {
        toast.error(t("paymentMethods.messages.verifySlickpay.noAccounts"));
        return false;
      }
    } catch (error) {
      console.error("خطأ في التحقق من SlickPay:", error.message);
      toast.error(t("paymentMethods.messages.verifySlickpay.error"));
      return false;
    } finally {
      setVerifyingSlickPay(false);
    }
  };

  const validateEnabledMethods = () => {
    const errors = [];

    Object.entries(paymentMethods).forEach(([key, method]) => {
      if (method.enabled) {
        if (key === "slickpay") {
          if (!method.apiKey) {
            errors.push(
              t("paymentMethods.messages.validate.slickpay.missingApiKey", {
                name: method.name,
              })
            );
          }
          if (!method.accountId) {
            errors.push(
              t("paymentMethods.messages.validate.slickpay.missingAccountId", {
                name: method.name,
              })
            );
          }
        } else if (key === "paymentLater") {
          // Pas de validation requise pour paymentLater - juste activé/désactivé
        } else {
          if (!method.accountId) {
            errors.push(
              t("paymentMethods.messages.validate.default.missingAccountId", {
                name: method.name,
              })
            );
          }
        }
      }
    });

    return errors;
  };

  const savePaymentMethods = async () => {
    const validationErrors = validateEnabledMethods();

    if (validationErrors.length > 0) {
      validationErrors.forEach((error) => {
        toast.error(error);
      });
      return;
    }

    try {
      setSaving(true);

      const methodsToSave = Object.keys(paymentMethods).reduce((acc, key) => {
        if (key === "slickpay") {
          acc[key] = {
            enabled: paymentMethods[key].enabled,
            accountId: paymentMethods[key].accountId,
            apiKey: paymentMethods[key].apiKey,
          };
        } else {
          acc[key] = {
            enabled: paymentMethods[key].enabled,
            accountId: paymentMethods[key].accountId,
          };
        }
        return acc;
      }, {});

      const updateData = {
        paymentMethods: methodsToSave,
        updatedAt: serverTimestamp(),
      };

      const existingDoc = await findSecretKeyDocByUser(account.user);

      if (existingDoc) {
        const docRef = doc(db, "secretKeys", existingDoc.id);
        await updateDoc(docRef, updateData);
      } else {
        const newDocData = {
          user: account.user,
          ...updateData,
        };
        await addDoc(collection(db, "secretKeys"), newDocData);
      }

      const methodsToSaveToStore = Object.keys(paymentMethods).reduce(
        (acc, key) => {
          acc[key] = {
            enabled: paymentMethods[key].enabled,
          };
          return acc;
        },
        {}
      );

      const updateDataToStore = {
        paymentMethods: methodsToSaveToStore,
        updatedAt: serverTimestamp(),
      };

      const storeDocRef = doc(db, "digitalStore", digitalStore.id);
      await updateDoc(storeDocRef, updateDataToStore);

      setOriginalPaymentMethods(paymentMethods);
      setHasChanges(false);
      toast.success(t("paymentMethods.messages.save.success"));
    } catch (error) {
      console.error(t("paymentMethods.messages.save.error"), error);
      toast.error(t("paymentMethods.messages.save.error"));
    } finally {
      setSaving(false);
    }
  };

  const checkForChanges = (updatedMethods) => {
    const hasChanged = Object.keys(updatedMethods).some((key) => {
      return (
        updatedMethods[key].enabled !== originalPaymentMethods[key]?.enabled ||
        updatedMethods[key].accountId !==
          originalPaymentMethods[key]?.accountId ||
        updatedMethods[key].apiKey !== originalPaymentMethods[key]?.apiKey
      );
    });
    setHasChanges(hasChanged);
  };

  const handleMethodToggle = (methodKey) => {
    const updatedMethods = {
      ...paymentMethods,
      [methodKey]: {
        ...paymentMethods[methodKey],
        enabled: !paymentMethods[methodKey].enabled,
      },
    };
    setPaymentMethods(updatedMethods);
    checkForChanges(updatedMethods);
  };

  const handleAccountIdChange = (methodKey, accountId) => {
    const updatedMethods = {
      ...paymentMethods,
      [methodKey]: {
        ...paymentMethods[methodKey],
        accountId: accountId,
      },
    };
    setPaymentMethods(updatedMethods);
    checkForChanges(updatedMethods);
  };

  const handleApiTokenChange = async (methodKey, apiKey) => {
    const updatedMethods = {
      ...paymentMethods,
      [methodKey]: {
        ...paymentMethods[methodKey],
        apiKey: apiKey,
        // Reset accountId quand on change l'API token
        accountId: "",
      },
    };
    setPaymentMethods(updatedMethods);
    checkForChanges(updatedMethods);

    if (methodKey === "slickpay" && apiKey.length > 10) {
      await verifySlickPayToken(apiKey);
    }
  };

  const getIconComponent = (iconName) => {
    const icons = {
      Smartphone,
      CreditCard,
      DollarSign,
      Wallet,
      Clock,
    };
    return icons[iconName] || DollarSign;
  };

  // Fonction pour vérifier si une méthode est complètement configurée
  const isMethodConfigured = (methodKey, method) => {
    if (!method.enabled) return true;

    if (methodKey === "slickpay") {
      return method.apiKey && method.accountId;
    } else if (methodKey === "paymentLater") {
      // PaymentLater est toujours configuré quand il est activé
      return true;
    } else {
      return method.accountId;
    }
  };

  // Fonction pour vérifier s'il y a des erreurs de validation
  const hasValidationErrors = () => {
    return validateEnabledMethods().length > 0;
  };

  const renderPaymentMethod = (methodKey, method) => {
    const IconComponent = getIconComponent(method.iconName);
    const isConfigured = isMethodConfigured(methodKey, method);
    const hasError = method.enabled && !isConfigured;

    return (
      <div
        key={methodKey}
        className={`bg-white dark:!bg-[#181819] border rounded-xl p-6 mb-4 shadow-sm hover:shadow-md transition-shadow duration-200 ${
          hasError
            ? "border-red-300 dark:!border-red-500"
            : "border-gray-200 dark:!border-[#3c3a3d]"
        }`}
      >
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-x-4">
            <div
              className={`w-12 h-12 ${method.color} rounded-lg flex items-center justify-center shadow-sm`}
            >
              {method.image && method.image.startsWith("http") ? (
                <img
                  src={method.image}
                  alt={method.name}
                  className="w-8 h-8 object-contain rounded"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ) : (
                <IconComponent size={24} className="text-white" />
              )}
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-100">
                  {method.name}
                </h3>
                <Switch
                  checked={method.enabled}
                  onChange={() => handleMethodToggle(methodKey)}
                  size="small"
                  className="ml-2"
                />
                {hasError && <AlertCircle size={16} className="text-red-500" />}
              </div>
              <p className="text-sm text-gray-500 dark:!text-gray-400">
                {method.description}
              </p>
            </div>
          </div>

          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip>
                {method.enabled
                  ? t("paymentMethods.method.tooltip.disable", {
                      name: method.name,
                    })
                  : t("paymentMethods.method.tooltip.enable", {
                      name: method.name,
                    })}
              </Tooltip>
            }
          >
            <span className="cursor-help">
              <Info
                size={18}
                className="text-gray-400 hover:text-gray-600 dark:!text-gray-300 dark:hover:!text-gray-100"
              />
            </span>
          </OverlayTrigger>
        </div>

        {/* Champs dynamiques */}
        <div className="space-y-3">
          {method.name === "سليك باي (باريدي موب و CIB)" ? (
            <>
              {/* API Token */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-2">
                  {t("paymentMethods.method.fields.apiTokenPublic.label")}{" "}
                  {method.enabled && <span className="text-red-500">*</span>}
                </label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder={t(
                      "paymentMethods.method.fields.apiTokenPublic.placeholder"
                    )}
                    className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200 ${
                      !method.enabled
                        ? "bg-gray-50 dark:!bg-[#2a2a2a] text-gray-400 cursor-not-allowed border-gray-300 dark:!border-[#3c3a3d]"
                        : hasError && !method.apiKey
                        ? "bg-white dark:!bg-[#181819] text-gray-900 dark:!text-gray-200 border-red-300 dark:!border-red-500"
                        : "bg-white dark:!bg-[#181819] text-gray-900 dark:!text-gray-200 border-gray-300 dark:!border-[#3c3a3d]"
                    }`}
                    value={method.apiKey || ""}
                    onChange={(e) =>
                      handleApiTokenChange(methodKey, e.target.value)
                    }
                    disabled={!method.enabled || verifyingSlickPay}
                  />
                  {verifyingSlickPay && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                      <Loader
                        size={16}
                        className="animate-spin text-purple-600"
                      />
                    </div>
                  )}
                </div>
                {method.enabled && !method.apiKey && (
                  <p className="text-red-500 text-xs mt-1">
                    {t("paymentMethods.method.fields.required")}
                  </p>
                )}
              </div>

              {/* UUID */}
              {method.accountId && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-2">
                    {t("paymentMethods.method.fields.accountUUID.label")}
                  </label>
                  <div className="flex items-center gap-2">
                    <input
                      type="text"
                      value={method.accountId}
                      className="flex-1 px-4 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg bg-gray-50 dark:!bg-[#2a2a2a] text-gray-600 dark:!text-gray-400 cursor-not-allowed"
                      disabled
                    />
                    <div className="flex items-center gap-1 text-green-600 dark:!text-green-400">
                      <CheckCircle size={16} />
                      <span className="text-xs">
                        {t("paymentMethods.method.fields.accountUUID.verified")}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : methodKey === "paymentLater" ? (
            /* Interface simplifiée pour Payment Later */
            method.enabled && (
              <div>
                <div className="bg-orange-50 dark:!bg-orange-900/20 border border-orange-200 dark:!border-orange-800 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <IconComponent
                      size={16}
                      className="text-orange-600 dark:!text-orange-400"
                    />
                    <h4 className="font-medium text-orange-800 dark:!text-orange-200">
                      {t("paymentMethods.methodsList.paymentLater.name")}
                    </h4>
                  </div>
                  <p className="text-sm text-orange-700 dark:!text-orange-300 mb-3">
                    {t("paymentMethods.methodsList.paymentLater.description")}
                  </p>
                </div>
              </div>
            )
          ) : (
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-2">
                {t("paymentMethods.method.fields.accountOrApiKey.label")}{" "}
                {method.enabled && <span className="text-red-500">*</span>}
              </label>
              <input
                type="text"
                placeholder={t(
                  "paymentMethods.method.fields.accountOrApiKey.placeholder",
                  { name: method.name }
                )}
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200 ${
                  !method.enabled
                    ? "bg-gray-50 dark:!bg-[#2a2a2a] text-gray-400 cursor-not-allowed border-gray-300 dark:!border-[#3c3a3d]"
                    : hasError && !method.accountId
                    ? "bg-white dark:!bg-[#181819] text-gray-900 dark:!text-gray-200 border-red-300 dark:!border-red-500"
                    : "bg-white dark:!bg-[#181819] text-gray-900 dark:!text-gray-200 border-gray-300 dark:!border-[#3c3a3d]"
                }`}
                value={method.accountId || ""}
                onChange={(e) =>
                  handleAccountIdChange(methodKey, e.target.value)
                }
                disabled={!method.enabled}
              />
              {method.enabled && !method.accountId && (
                <p className="text-red-500 text-xs mt-1">
                  {t("paymentMethods.method.fields.required")}
                </p>
              )}
            </div>
          )}

          {/* Status */}
          {method.enabled && (
            <div className="flex items-center gap-2 text-sm">
              <div
                className={`w-2 h-2 rounded-full ${
                  isConfigured ? "bg-green-500" : "bg-red-500"
                }`}
              ></div>
              <span
                className={`${
                  isConfigured
                    ? "text-green-600 dark:!text-green-400"
                    : "text-red-600 dark:!text-red-400"
                }`}
              >
                {isConfigured
                  ? t("paymentMethods.method.status.configured")
                  : t("paymentMethods.method.status.notConfigured")}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };
  const isRTL = i18n.dir() === "rtl";

  return (
    <div
      className="flex min-h-screen bg-gray-50 dark:!bg-[#141414]"
      dir={isRTL ? "rtl" : "ltr"}
    >
      {showSideBar && (
        <div
          style={{
            width: "250px",
            flexShrink: 0,
            transition: "width 0.6s ease",
          }}
        >
          <Sidebar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
        </div>
      )}
      <div
        className="px-3 w-full dark:!bg-[#141414]"
        style={{ flex: 1, backgroundColor: "#fbf8fc" }}
      >
        <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
        <div className="m-3 p-0">
          {/* Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-lg shadow-sm border border-gray-200 dark:!border-[#3c3a3d] p-6 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-purple-100 dark:!bg-[#181819] rounded-lg flex items-center justify-center">
                <CreditCard
                  size={20}
                  className="text-purple-600 dark:text-purple-400"
                />
              </div>
              <div>
                <h1
                  className="text-2xl font-bold text-gray-800 dark:text-gray-300"
                  style={{ color: "#8D5DA7" }}
                >
                  {t("paymentMethods.pageTitle")}
                </h1>
                <p className="text-gray-600 dark:text-gray-400 mt-1">
                  {t("paymentMethods.pageDescription")}
                </p>
              </div>
            </div>
          </div>

          {/* Payment Methods */}
          <div className="w-4/5 mx-auto">
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-300 mb-2">
                {t("paymentMethods.availableMethods.title")}
              </h2>
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                {t("paymentMethods.availableMethods.description")}
              </p>
            </div>

            {loading ? (
              <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#9b59bf] dark:!border-[#9b59bf]"></div>
                <span className="ml-3 text-gray-600 dark:!text-gray-300">
                  {t("paymentMethods.loading")}
                </span>
              </div>
            ) : (
              <>
                <div className="grid gap-4 mb-8">
                  {Object.entries(paymentMethods).map(([key, method]) =>
                    renderPaymentMethod(key, method)
                  )}
                </div>

                {/* Save Button */}
                <div className="sticky bottom-0 bg-white dark:!bg-[#181819] border-t border-gray-200 dark:!border-[#3c3a3d] p-6 rounded-lg shadow-lg mb-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      {hasChanges && (
                        <div className="flex items-center gap-2 text-amber-600 dark:!text-amber-400">
                          <div className="w-2 h-2 bg-amber-500 dark:!bg-amber-400 rounded-full animate-pulse"></div>
                          <span className="text-sm font-medium">
                            {t("paymentMethods.unsavedChanges")}
                          </span>
                        </div>
                      )}
                      {hasValidationErrors() && (
                        <div className="flex items-center gap-2 text-red-600 dark:!text-red-400">
                          <AlertCircle size={16} />
                          <span className="text-sm font-medium">
                            {t("paymentMethods.validationError")}
                          </span>
                        </div>
                      )}
                    </div>
                    <button
                      onClick={savePaymentMethods}
                      disabled={!hasChanges || saving}
                      className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                        hasChanges && !saving
                          ? "bg-purple-600 hover:bg-purple-700 text-white shadow-md hover:shadow-lg"
                          : "bg-gray-300 text-gray-500 dark:!bg-[#3c3a3d] dark:!text-gray-400 cursor-not-allowed"
                      }`}
                    >
                      {saving ? (
                        <>
                          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          <span>{t("paymentMethods.saveButton.saving")}</span>
                        </>
                      ) : (
                        <>
                          <Save size={18} />
                          <span>{t("paymentMethods.saveButton.default")}</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodsPage;
